import { BackendModel, BackendService } from "../../core/backend.service";

export class CostoEnvio extends BackendModel {

    static path = '/costo-envio/';
  
    id: number;
    codigoPostal: string;
    costoEnvio: number;
    nombreintervalos: string;
  
    constructor(protected backendService: BackendService, model?: CostoEnvio) {
      super(backendService, model);
    }
  }


// WEBPACK FOOTER //
// ./src/app/pedido/costo-envio/costo-envio.model.ts